import { Input, Row, InputNumber } from 'antd';
import React, { Component } from 'react';
import Compared from "../../Compared";

class Title extends Component {
    render() {
        const { onChange, data, t_type, name } = this.props;
        return (
            <div className="components-title">
                <div className="title-input">
                    <div className="desc">截止当月</div>
                    <div className="name">
                        <div>总评分</div>
                        <div>口味</div>
                        <div>环境</div>
                        <div>服务</div>
                        <div>品种</div>
                    </div>
                    <div className="value">
                        <Compared
                            data={{ index: 0, key: 'rate', title: [name], sqlName: "_5_9_1", name: '总评分', t_type, type: "number" }}
                        >
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                defaultValue={Number(data.rate || "0") || ""}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    console.log(value);
                                    onChange('rate', value || 0)
                                }}
                            />
                        </Compared>
                        <Compared
                            data={{ index: 0, key: 'taste', title: [name], sqlName: "_5_9_1", name: '口味', t_type, type: "text" }}
                        >
                            <Input defaultValue={data.taste} onBlur={e => onChange('taste', e.target.value || "")} />
                        </Compared>
                        <Compared
                            data={{ index: 0, key: 'environment', title: [name], sqlName: "_5_9_1", name: '环境', t_type, type: "text" }}
                        >
                            <Input defaultValue={data.environment} onBlur={e => onChange('environment', e.target.value || "")} />
                        </Compared>
                        <Compared
                            data={{ index: 0, key: 'service', title: [name], sqlName: "_5_9_1", name: '服务', t_type, type: "text" }}
                        >
                            <Input defaultValue={data.service} onBlur={e => onChange('service', e.target.value || "")} />
                        </Compared>
                        <Compared
                            data={{ index: 0, key: 'varieties', title: [name], sqlName: "_5_9_1", name: '品种', t_type, type: "text" }}
                        >
                            <Input defaultValue={data.varieties} onBlur={e => onChange('varieties', e.target.value || "")} />
                        </Compared>
                    </div>
                </div>
                <div className="num">
                    <div className="item">
                        <span className="name">点评数量</span>
                        <Compared
                            data={{ index: 0, key: 'num', title: [name], sqlName: "_5_9_1", name: '点评数量', t_type, type: "number" }}
                        >
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                defaultValue={Number(data.num || "0") || ""}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    onChange('num', value)
                                }}
                            />
                        </Compared>
                    </div>
                    <div className="item">
                        <span className="name">人均消费额</span>
                        <Compared
                            data={{ index: 0, key: 'price', title: [name], sqlName: "_5_9_1", name: '人均消费额', t_type, type: "number" }}
                        >
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                defaultValue={Number(data.price || "0") || ""}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    onChange('price', value)
                                }}
                            />
                        </Compared>
                    </div>
                </div>
            </div>
        );
    }
}

export default Title;


// WEBPACK FOOTER //
// ./src/components/table/5.0/5-9/Title.js